import { emptySplitApi } from "./empty-split-api";
import type {
  ConsultDebrief,
  ConsultOutcome
} from "./types/consult-debriefs.type";

export const consultDebriefsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getConsultDebrief: builder.query<ConsultDebrief, number>({
      query: (id) => ({ url: `/ai/consult-debriefs/${id}/` }),
      providesTags: (_result, _error, id) => [{ type: "ConsultDebriefs", id }]
    }),
    confirmConsultOutcome: builder.mutation<
      ConsultDebrief,
      { id: number; outcome: ConsultOutcome }
    >({
      query: ({ id, outcome }) => ({
        url: `/ai/consult-debriefs/${id}/confirm-outcome/`,
        method: "PATCH",
        body: { outcome }
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: "ConsultDebriefs", id }
      ]
    })
  })
});

export const { useGetConsultDebriefQuery, useConfirmConsultOutcomeMutation } =
  consultDebriefsApi;
